import { useEffect, useState } from 'react';

import { projectGrad, projectMono } from '@/lib/projectVisuals';

// 2단 fallback 썸네일:
// 1) backend /api/projects/{prefix}/icon — GCS의 실제 게임 아이콘 (있을 때)
// 2) projectGrad + projectMono — 못 쓰면 prefix별 결정론적 grad 위 약자
//
// placeholder 4종 회전은 의도적으로 제거 — 100개 게임이 25개씩 같은 아이콘을 가지면
// 시각적 정체성이 잘못 부여됨. 진짜 아이콘이 없으면 prefix별 grad+mono로 대체.
export interface ProjectThumbProps {
  prefix: string;
  display_name?: string | null;
  iconUrl?: string | null;
  size: number;
  // 카드 (small) 와 detail header (large)의 font-weight/size가 다르므로
  // grad fallback에서만 별도 클래스 적용 가능하도록 className 제공.
  className?: string;
  style?: React.CSSProperties;
}

export function ProjectThumb({
  prefix,
  display_name,
  iconUrl,
  size,
  className,
  style,
}: ProjectThumbProps) {
  // iconUrl이 null이면 GCS 시도 자체를 건너뛰고 바로 grad fallback.
  const [failed, setFailed] = useState<boolean>(!iconUrl);

  // prefix/iconUrl이 바뀌면 상태를 초기로 되돌림 (같은 컴포넌트 재사용 시).
  useEffect(() => {
    setFailed(!iconUrl);
  }, [prefix, iconUrl]);

  if (failed || !iconUrl) {
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: Math.max(8, Math.floor(size * 0.16)),
          background: projectGrad(prefix),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontFamily: 'var(--sc-font-display, "Pretendard")',
          fontWeight: 900,
          fontSize: Math.max(14, Math.floor(size * 0.34)),
          letterSpacing: '-0.02em',
          flexShrink: 0,
          ...style,
        }}
      >
        {projectMono({ prefix, display_name })}
      </div>
    );
  }

  return (
    <img
      src={iconUrl}
      alt={projectMono({ prefix, display_name })}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className={className}
      onError={() => setFailed(true)}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(8, Math.floor(size * 0.16)),
        objectFit: 'cover',
        background: '#f4f4f4',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
